module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABUUlEQVRYR+2XvUrEQBSFz43IgIJoChHsFHwTW2OdKCTTab+VhRb6CpaZQZ/A1sLK1kdQ2N5CENc/zJEpAlskcbMJppk0ae6955szU9wjGPiTgfVRC2CtPSJ5QXKtC6SIvAA4ybLssmpOLUCe528AlurEReQHwDnJTxFxc0YkV2vqJ1rr5bYALBucGMlJxYCxiHyRdAzb7j9VszB9AK115WGbHCgBCqXUVpIk4zZX4WCMMVcADlzf3AAi8p5lWe1VNEEZY05JnnkA74B3wDvgHfAOeAe8A50cAFAEQbCTpuljy40osNZek4y7Arj+AsB3GwAAAYDFsmfulewP0ScA9yKyT3KlqbZ3ALcNK6U24zh+ttbuFUVx898AH2EYrkdR9GqM2SV52zdAYzBxYiLyAOAOwCHJjQaA9sHEGHMMwEWzurQz05ucO5rNNL2HosHT8S8Hr1Aw8NCEhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_phone.png
// module id = 706
// module chunks = 0